import { Navigate } from 'react-router-dom';
import { useAuth } from '../store/AuthContext';
import { JSX } from 'react';
import LoadingSpinner from '../components/Loading/LoadingSpinner';

const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
  const { user, loading } = useAuth();

  if (loading) return <div><LoadingSpinner /></div>;
  return user ? children : <Navigate to="/login" />;
};

export default ProtectedRoute;
